export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14607.edbbf5da.jpg";